import { jsx as _jsx } from "react/jsx-runtime";
import { tooltipate } from "../index";
export const KLabel = ({ tooltip, dark = false, text, required = false }) => {
    return tooltipate(_jsx("span", { className: `klabel${required ? " required" : ""}${dark ? " darkmode" : ""}`, children: text }), tooltip, undefined, true);
};
